import 'popper.js/dist/popper.min.js';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter, Route } from 'react-router-dom';
import App from './app';
import "../www/assets/css/overrides.css"

document.addEventListener('DOMContentLoaded', () => {
	const container = document.getElementById('app');
	const root = createRoot(container);
	root.render(
		<HashRouter>
			<Route path='/:view?/:viewID?' component={App} />
		</HashRouter>
	);
});
